import { ReactElement, ReactNode } from 'react';
import { PrimaryButton, SecondaryButton, StatusBar } from '@weareopenr/component-library';
import styles from '../PublishModal.module.scss';

interface IPublishFlowFooterProps {
  leftButtonIsBack: boolean;
  onLeftButtonClick: () => void;
  isSummaryStep: boolean;
  onIncrementStep: (e: React.MouseEvent<HTMLButtonElement>) => void;
  continueDisabled: boolean;
  isSubmitting: boolean;
  primaryLabel: string;
  errorMessage: string | ReactNode | null;
}

const PublishFlowFooter = ({
  leftButtonIsBack,
  onLeftButtonClick,
  isSummaryStep,
  onIncrementStep,
  continueDisabled,
  isSubmitting,
  primaryLabel,
  errorMessage,
}: IPublishFlowFooterProps): ReactElement => (
  <>
    <div className={styles['buttons-container']}>
      <SecondaryButton size="full-width" buttonStyle="outline" onClick={onLeftButtonClick} type="button">
        {leftButtonIsBack ? 'Back' : 'Cancel'}
      </SecondaryButton>
      <PrimaryButton
        onClick={isSummaryStep ? undefined : onIncrementStep}
        type={isSummaryStep ? 'submit' : 'button'}
        size="full-width"
        disabled={continueDisabled}
        loading={isSubmitting}
      >
        {isSubmitting ? 'Publishing' : primaryLabel}
      </PrimaryButton>
    </div>
    <div className={styles['error-banner']}>{errorMessage && <StatusBar message={errorMessage} variant="error" />}</div>
  </>
);

export default PublishFlowFooter;
